import { WeighingTypeEnum } from "../../../../domain/model/model-enums";

export class StoreTrialPhaseType {
  static readonly Initial: string = 'Initial';
  static readonly Interim: string = 'Interim';
  static readonly Final: string = 'Final';
  private weighingType: WeighingTypeEnum = WeighingTypeEnum.Initial;

  constructor(
    readonly name: string) {
    switch (name) {
      case StoreTrialPhaseType.Initial:
        this.weighingType = WeighingTypeEnum.Initial;
        break;
      case StoreTrialPhaseType.Interim:
        this.weighingType = WeighingTypeEnum.Interim;
        break;
      case StoreTrialPhaseType.Final:
        this.weighingType = WeighingTypeEnum.Final;
        break;
      default:
        throw new Error('Invalid trial phase type');
    }
  }

  asWeighingType(): WeighingTypeEnum {
    return this.weighingType;
  }
}
